<template lang="pug">
	.spawn-sections-list
		.spawn-sections(v-if="_.size(data) > 0")
			.spawn-section(v-for="(sectionName) in data")

				.spawn-section-name
					select.custom-select.custom-select-sm(v-on:change="changeSection(sectionName, $event.target.value)")
						option(v-for="section in sections" :selected="sectionName === section.title" :value="section.title") {{section.title}}
					.spawn-section-remove(@click="removeSection(sectionName)")
						i.fa.fa-times

		.add-new-section
			//-select.custom-select.custom-select-sm(v-on:change="addNewsection($event.target)")
			select.custom-select.custom-select-sm(v-on:change="addNewSection($event.target)")
				option(:selected="true" value="none") Add new section
				option(v-for="section in sections" v-if="!data[section.title]" :selected="false" :value="section.title") {{section.title}}

</template>

<script>

	import Screen from './../../../mixins/screen';

	import {Project} from './../../../services/Project';
	import {Settings} from './../../../services/Settings';
	import {Section} from "../../../services/Section";

	export default {
		name: "SpawnSectionsList",
		mixins: [Screen],
		screen: {
			updateOn: ["Selected Version Changed", "Setting Changed", "Project Version Settings Changed"]
		},
		props: ['setting'],
		data() {

			this.Project = Project;
			this.Settings = Settings;
			this._ = _;

			this.sections = [];
			this.projectSections = Object.values(Section.Sections)
				.filter(section => section.project_id === this.setting.project_id);

			this.data = [];

			return {
				showed: true
			}

		},
		methods: {
			collectData() {

				this.sections = Object.values(Section.Sections)
					.filter(section => section.project_id === this.setting.project_id && section.id !== this.setting.id);

				if (this.setting.Data.expandSections) {
					this.data = this.setting.Data.expandSections.split(' ');

					for (let i = 0; i < this.data.length; i++) {
						//let s = this.projectSections.find(section =>  section.id === parseInt(this.data[i]));
						this.data[i] = this.projectSections.find(section =>  section.id === parseInt(this.data[i])).title;

					}
				}

				else this.data = [];

			},
			addNewSection(el) {

				if (el.value === "none") return;

				if (this.data.includes(el.value)) return;

				this.data.push(el.value);

				this.$forceUpdate();

				el.value = 'none';

				this.delaySave();

			},
			changeSection(oldSection, newSection) {

				if (this.data.includes(newSection)) {
					this.removeSection(oldSection);
					return;
				}

				let index = this.data.indexOf(oldSection)

				this.data[index] = newSection;

				this.$forceUpdate();

				this.delaySave();

			},
			removeSection(sectionName) {

				let index = this.data.indexOf(sectionName);

				if (index > -1) {

					this.data.splice(index, 1);

				}

				this.$forceUpdate();

				this.delaySave();

			},

			delaySave() {

				let newData = [...this.data];

				for (let i = 0; i < newData.length; i++) {

					newData[i] = this.projectSections.find(section =>  section.title === newData[i]).id;

				}

				newData = newData.join(' ');

				this.projectSections.find(section => section.id === this.setting.id).Data.expandSections = newData;

				clearTimeout(this.saveTimeout);

				this.saveTimeout = setTimeout(() => {

					Section.saveSectionData(this.setting, 'expandSections', newData);

				}, 200);

			}
		}
	}
</script>

<style lang="sass">

	.spawn-sections-list
		display: flex
		justify-content: space-between
		user-select: none
		position: relative
		flex-direction: column

		.spawn-sections
			position: relative
			font-size: 12px
			overflow: hidden
			padding-bottom: 5px

			.spawn-section
				display: flex
				flex-direction: column
				position: relative
				user-select: none

				.spawn-section-name
					display: flex
					flex-direction: row
					justify-content: space-between

					.custom-select
						width: 315px

					.spawn-section-remove
						cursor: pointer
						transition: 0.2s
						padding: 4px 7px
						font-size: 14px
						color: #fff

						&:hover
							color: #20a8d8

						.fa-times
							padding-top: 8px

</style>
